import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dom = $(el);

    const tabs = dom.find('[role="tab"]');
    const panels = dom.find('[role="tabpanel"]');

    const open = tab => {
        tabs.attr('aria-selected', null).attr('tabindex', -1);
        panels.attr('hidden', true);

        tab.attr('aria-selected', true).attr('tabindex', null).focus();
        $(tab.attr('href')).attr('hidden', null);
    };

    const click = e => {
        e.preventDefault();
        open($(e.triggerTarget));
    };

    const keydown = e => {
        const key = e.keyCode || e.which;
        if (key === 37 || key === 39) {
            let index = tabs.index(e.currentTarget);
            index += (key === 37 ? -1 : 1);
            if (index < 0) {
                index = tabs.length - 1;
            } else if (index === tabs.length) {
                index = 0;
            }
            open(tabs.eq(index));
        }
    };

    const init = () => {
        tabs.on('click', click);
        tabs.on('keydown', keydown);
    };

    const destroy = () => {
        tabs.off('click', click);
        tabs.off('keydown', keydown);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Tabs.js